import React from "react";
import { useTranslation } from "react-i18next";
import { LocaleLink } from "../../i18n/LocaleLink";

export const ServiceOneItem = ({ service }) => {
  const { t } = useTranslation();

  return (
    <div className="services-item">
      <div className="services-content">
        <div className="content-top">
          <div className="icon">
            <i className={service.showCaseIcon}></i>
          </div>

          <h2 className="title">{service.title} </h2>
        </div>

        <div className="services-thumb">
          <img src={service.showcaseImage} alt="" />

          <LocaleLink
            to={service.href}
            state={{ serviceId: service.id }}
            className="btn transparent-btn"
          >
            {t("common.seeMore")}
          </LocaleLink>
        </div>

        <ul className="list-wrap">
          {service.threeMostImportantPoints.map((point, index) => (
            <li key={index}>{point}</li>
          ))}
        </ul>
      </div>
    </div>
  );
};
